import { createFileRoute } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { MarketingHeader, PortalFooter } from '@/components/portal-shell'
import { type AppLanguageCode, type TKey, translateApp } from '@/lib/i18n'

export const Route = createFileRoute('/terms')({
	ssr: true,
	component: TermsPage
})

function TermsPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = (key: TKey) => translateApp(appLanguage, key)

	return (
		<LegalPage
			appLanguage={appLanguage}
			eyebrow={t('common:legal.eyebrow')}
			lastUpdated={translateApp(
				appLanguage,
				'common:legal.last_updated',
				{
					date: formatLegalDate(appLanguage)
				}
			)}
			title={t('common:legal.terms.title')}
		>
			<h2>{t('common:legal.terms.access.title')}</h2>
			<p>{t('common:legal.terms.access.description')}</p>
			<h2>{t('common:legal.terms.acceptable_use.title')}</h2>
			<p>{t('common:legal.terms.acceptable_use.description')}</p>
			<h2>{t('common:legal.terms.availability.title')}</h2>
			<p>{t('common:legal.terms.availability.description')}</p>
		</LegalPage>
	)
}

export function formatLegalDate(language: AppLanguageCode) {
	return new Intl.DateTimeFormat(language, {
		dateStyle: 'long',
		timeZone: 'UTC'
	}).format(new Date('2026-07-14T00:00:00.000Z'))
}

function LegalPage(props: {
	appLanguage: AppLanguageCode
	eyebrow: string
	lastUpdated: string
	title: string
	children: ReactNode
}) {
	return (
		<div className='portal-page min-h-svh'>
			<MarketingHeader appLanguage={props.appLanguage} />
			<main className='portal-container simple-page py-9 pb-20'>
				<div className='simple-page__intro mb-7 max-w-[42.5rem]'>
					<p className='portal-eyebrow'>{props.eyebrow}</p>
					<h1>{props.title}</h1>
					<p className='portal-lead'>{props.lastUpdated}</p>
				</div>
				<article className='legal-copy max-w-[47.5rem]'>
					{props.children}
				</article>
			</main>
			<PortalFooter appLanguage={props.appLanguage} />
		</div>
	)
}

export { LegalPage }
